import * as React from 'react';
import { IOption } from '@cian/ui-kit/types';
import { InlineText2, Select } from '@cian/ui-kit';
import * as styles from '../Filters/Filters.css';

interface IRegionDropdownProps {
  regions: IOption[];
  selectedRegion: number;
  onChange: (regionId: number) => void;
}

export function RegionDropdown({ regions, selectedRegion, onChange }: IRegionDropdownProps) {
  return (
    <>
      <InlineText2>Регион</InlineText2>
      <div className={styles['input__wrapper']}>
        <Select width={160} options={regions} value={selectedRegion} onChange={onChange} />
      </div>
    </>
  );
}
